// Dispatched on `window` (not imported directly) so that low-level modules like
// tokenAuth/axiosInstance never need to import the redux store — every thunk file
// already imports axiosInstance, so any import the other way round is a cycle.
export const SESSION_EXPIRED_EVENT = 'auth:sessionExpired';

// Dispatched after a successful token refresh, so long-lived connections that
// authenticated with the previous access token (e.g. the entity-updates websocket)
// can re-authenticate with the new one.
export const TOKEN_REFRESHED_EVENT = 'auth:tokenRefreshed';
